export const lineStories = [
    {
        label: 'stacked lines',
        link: {
            kind: 'Line',
            story: 'stacked lines',
        },
    },
    {
        label: 'linear x scale',
        link: {
            kind: 'Line',
            story: 'linear x scale',
        },
    },
    {
        label: 'time x scale',
        link: {
            kind: 'Line',
            story: 'time x scale',
        },
    },
    {
        label: 'real time chart',
        link: {
            kind: 'Line',
            story: 'real time chart',
        },
    },
    {
        label: 'custom dot symbol',
        link: {
            kind: 'Line',
            story: 'custom dot symbol',
        },
    },
    {
        label: 'adding markers',
        link: {
            kind: 'Line',
            story: 'adding markers',
        },
    },
    {
        label: 'holes in data',
        link: {
            kind: 'Line',
            story: 'holes in data',
        },
    },
    {
        label: 'different serie lengths',
        link: {
            kind: 'Line',
            story: 'different serie lengths',
        },
    },
    {
        label: 'custom min/max y',
        link: {
            kind: 'Line',
            story: 'custom min/max y',
        },
    },
    {
        label: 'formatting axis values',
        link: {
            kind: 'Line',
            story: 'formatting axis values',
        },
    },
    {
        label: 'formatting tooltip values',
        link: {
            kind: 'Line',
            story: 'formatting tooltip values',
        },
    },
]
